import u from 'updeep';
import { handleActions } from 'redux-actions';
import * as actions from './allMobileTranslateActions';
// import { stat } from 'fs-extra';

const initialState = {
    hideHeaderFooter: false,
    bookPages: [],
    bookCurrentPage: 2,
    pageContent: '',
    isFetchingPageContent: false,
    isFetchingStoryPages: false,
    storyPages: [],
    parentStory: '',
    confirmModalVisible: false,
    isUpdatingPageContent: false,
    updatedPageContent: {},
    isOriginalBookReaderVisible:false,
    isCheckingMobileTranslations: false,
    isDraftLoading: false,
    newDraftStoryId: '',
    newDraftParentId: '',
    isFetchingStoryLanguage: false,
    storyLanguage: {},
    audioResponse: null,
    isFetchingAudioResponse: false,
    showPublish: true
}

export default handleActions({
    [actions.headerFooterHideAction]: (state, action) => u({
        hideHeaderFooter: true
      }, state),
    [actions.setBookPage]: (state, action) => u({
        bookPages: action.payload ? action.payload.bookPages : []
    },  state),
    [actions.setBookCurrentPage]: (state, action) => u({
        bookCurrentPage: action.payload ? action.payload.bookCurrentPage : 1
    }, state),
    [actions.fetchPageContent]: (state, action) => u({
        isFetchingPageContent: false
    }, state),
    [actions.receivePageContent]: (state, action) => u({
        isFetchingPageContent: false,
        pageContent: action.payload.data
    }, state),
    [actions.fetchBookPages]: (state, action) => u({
        isFetchingStoryPages: true 
      }, state),
      [actions.receiveBookPages]: (state, action) => u({
        isFetchingStoryPages: false,
        storyPages: action.payload.data.pages,
        parentStory: action.payload.data.parent_story
      }, state),
    [actions.confirmModalVisibleAct]: (state, action) => u({
        confirmModalVisible: action.payload.confirmModalVisible
    }, state),
    [actions.postUpdatePageContent]: (state, action)=> u({
        isUpdatingPageContent: true
    }, state),
    [actions.openOriginalBookReader]: (state, action)=> u({
        isOriginalBookReaderVisible: true
    }, state),
    [actions.closeOriginalBookReader]: (state, action)=> u({
        isOriginalBookReaderVisible: false
    }, state),
    [actions.receiveUpdatePageContent]: (state, action)=> u({
        isUpdatingPageContent: false,
        updatedPageContent: action.payload.data
    }, state),
    [actions.fetchCheckTranslationsMobileTranslate]: (state, action) => u({
        isCheckingMobileTranslations: true
    }, state),    
    [actions.receiveCheckTranslationsMobileTranslate]: (state, action) => u({
        isCheckingMobileTranslations: false,
        availableTranslations: action.payload.data
    }, state),
    [actions.fetchMobileTranslations]: (state, action) => u({
        isDraftLoading: true
    }, state),
    [actions.receiveMobileTranslations]: (state, action) => u({
        isDraftLoading: false,
        newDraftStoryId: action.payload.translated_story_id,
        newDraftParentId: action.payload.parent_story_id
    }, state),
    [actions.fetchStoryInfo]: (state, action) => u({
        isFetchingStoryLanguage: true
    }, state),
    [actions.receiveStoryInfo]: (state, action) => u({
        isFetchingStoryLanguage: false,
        showPublish: action.payload.data.publishAccess,
        storyLanguage: action.payload.data.language
    }, state),
    [actions.fetchAudioResponse]: (state, action) => u({
        isFetchingAudioResponse: true,
    }, state),
    [actions.receiveAudioResponse]: (state, action) => u({
        isFetchingAudioResponse: false,
        audioResponse: action.payload.data
    }, state),
    [actions.fetchAudioResponseError]: (state, action) => u({
        isFetchingAudioResponse: false,
    }, state),
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/allMobileTranslateReducer.js